require('./polyfill');
const tools = require('./tools');
import AnimEngine from './animations/animEngine';
import Animation from './animations/animation';
import Swiper from 'swiper';
const logoAnim = require('./animLogo/animLogo').default;
import Overlay from './overlay';
import Player from "@vimeo/player";

const sukoaProject = {
    swipers: [],
    reinitSliderTimeout: null,
    animEngine: new AnimEngine(),
    touchUser: false,
    mouseUser: false,
    init() {
        document.getElementsByTagName('html')[0].classList.remove('no-js');
        sukoaProject.checkTouchUser();
        sukoaProject.checkMouseUser();
        sukoaProject.initSliders();
        sukoaProject.collapsibles();
        sukoaProject.headerSliderState();
        sukoaProject.articlesList();
        sukoaProject.searchButton();
        sukoaProject.windowResizeActions();
        sukoaProject.animEngine.loadImages();
        sukoaProject.burger();
        sukoaProject.shareButtons();
        sukoaProject.printBtn();
        sukoaProject.initOverlay();
        sukoaProject.authorInstanceFct();
        logoAnim.init();

    },

    authorInstanceFct() {
            if(document.body.classList.contains('author')) {
                let editButtons = document.getElementsByClassName('mgnlLikeBtn');
                tools.each(editButtons, button => {
                    button.addEventListener('click', evt => {
                        evt.stopPropagation();
                        let dataUrl = button.getAttribute('data-url');
                        if(dataUrl) {
                            evt.preventDefault();
                            window.open(dataUrl);
                        }
                    })
                })
            }
    },

    windowResizeActions() {
        window.onresize = evt => {
            sukoaProject.checkTouchUser();
            sukoaProject.checkMouseUser();
            if(sukoaProject.reinitSliderTimeout) {
                clearTimeout(sukoaProject.reinitSliderTimeout);
            }
            sukoaProject.reinitSliderTimeout = window.setTimeout(
                () => {
                    sukoaProject.initSliders();
                    sukoaProject.reinitSliderTimeout = null;
                }, 700);
            // sukoaProject.checkFilteredImagesSizes();
        }
    },

    initOverlay() {
        if(!tools.isEditMode()){
            let overlay = new Overlay('fs-view');
        }
    },

    checkFilteredImagesSizes() {
        let filteredImages = document.getElementsByClassName('filtered_image');
        tools.each(filteredImages, img => {
            let parent = img.parentNode;

            if(img.clientWidth < parent.clientWidth) {
                // enlarge image
                img.style.width = '100%';
                img.style.maxWidth = '100%';
                img.style.height = 'auto';
                img.style.maxHeight = 'none';
                img.style.transform = 'translateX(-50%)';
                img.style.top = '0';
                img.style.left = '50%';
            } else if( img.clientHeight < parent.clientHeight) {
                img.style.height = '100%';
                img.style.maxHeight = '100%';
                img.style.width = 'auto';
                img.style.maxWidth = 'none';
                img.style.transform = 'translateY(-50%)';
                img.style.top = '50%';
                img.style.left = '0';
            }
        })
    },

    isSmallScreen() {
        return window.innerWidth < 640;
    },

    checkTouchUser() {
        sukoaProject.touchUser = false;
        document.body.classList.remove('touch-user');
        if (sukoaProject.isSmallScreen()) {
            sukoaProject.touchUser = true;
            document.body.classList.add('touch-user');
        } else {
            window.addEventListener('touchstart', function onFirstTouch() {
                sukoaProject.touchUser = true;
                document.body.classList.add('touch-user');
                window.removeEventListener('touchstart', onFirstTouch, {passive: true});
            }, {passive: true})
        }
    },

    checkMouseUser() {
        sukoaProject.mouseUser = false;
        window.addEventListener('mousemove', function onFirstMove() {
            sukoaProject.mouseUser = true;
            window.removeEventListener('mousemove', onFirstMove, {passive: true});
        }, {passive: true})
    },

    initSliders() {
        tools.each(sukoaProject.swipers, slider => slider.destroy());
        sukoaProject.swipers = [];
        let articleHeaderWrapper = document.querySelector('.article-header');
        if (articleHeaderWrapper) {
            tools.each(articleHeaderWrapper.getElementsByClassName('images-slider'), sliderwrapper => {
                sukoaProject.swipers.push(
                    new Swiper(sliderwrapper, {
                        loop: true,
                        spaceBetween: 7,
                        simulateTouch: false,
                        navigation: {
                            nextEl: '.slider-next',
                            prevEl: '.slider-prev'
                        },
                        pagination: {
                            el: '.pagination',
                            type: 'fraction'
                        }
                    })
                );
            });
        }

        let contentWrapper = document.querySelector('.content-wrapper');
        if (contentWrapper) {
            tools.each(contentWrapper.getElementsByClassName('images-slider'), sliderwrapper => {
                let changedSlides = 0;
                sukoaProject.swipers.push(
                    new Swiper(sliderwrapper, {
                        loop: true,
                        spaceBetween: 7,
                        simulateTouch: false,
                        navigation: {
                            nextEl: '.slider-next',
                            prevEl: '.slider-prev'
                        },
                        pagination: {
                            el: '.pagination',
                            type: 'fraction'
                        },
                        on: {
                            slideChange() {
                                if (changedSlides > 0) {
                                    sliderwrapper.classList.add('active');
                                    this.on.sliderChange = null;
                                } else {
                                    changedSlides++;
                                }
                            }
                        }
                    })
                );
            });
        }

        tools.each(document.getElementsByClassName('articles-slider'), sliderwrapper => {
            if (!sliderwrapper.classList.contains('single_slide')) {
                sukoaProject.swipers.push(
                    new Swiper(sliderwrapper, {
                        loop: true,
                        loopedSlides: null,
                        loopAdditionalSlides: 0,
                        speed: 700,
                        slideDuplicateActiveClass: 'active',
                        simulateTouch: false,
                        autoplay: {
                            delay: 3000
                        },

                        slidesPerView: 'auto',
                        breakpoints: {
                            1023: {
                                slidesPerView: 1
                            }
                        },
                        keyboard: {
                            enabled: true
                        },
                        navigation: {
                            nextEl: '.slider-next',
                            prevEl: '.slider-prev'
                        },

                        on: {
                            init() {
                                setTimeout(() => {
                                    tools.each(this.slides, slide => {
                                        if (slide.classList.contains('active')) {
                                            slide.classList.remove('active');
                                        }
                                        this.update();
                                    })
                                }, 1000);

                            }
                        }

                    })
                );
            }
        });

        tools.each(document.getElementsByClassName('infobox-slider'), sliderwrapper => {
            sukoaProject.swipers.push(
                new Swiper(sliderwrapper, {
                    loop: false,
                    speed: 700,
                    simulateTouch: false,
                    autoplay: false,
                    spaceBetween: 10,
                    slidesPerView: 2,
                    breakpoints: {
                        639: {
                            slidesPerView: 1
                        }
                    },
                    keyboard: {
                        enabled: true
                    },
                    navigation: {
                        nextEl: '.slider-next',
                        prevEl: '.slider-prev'
                    }
                })
            )
        })
    },

    collapsibles() {
        let collapsibles = document.getElementsByClassName('collapsible');
        tools.each(collapsibles, collapsible => {
            let button = collapsible.querySelector('.key');
            let texts = collapsible.querySelector('.text');

            if (button && texts) {
                button.addEventListener('click', evt => {
                    if (collapsible.classList.contains('opened')) {
                        collapsible.classList.remove('opened');
                    } else {
                        collapsible.classList.add('opened');
                    }
                })
            }
        })
    },

    headerSliderState() {
        let header = document.querySelector('.article-header');
        if(header) {
            let clickHandler = null;
            let imageHeader = header.querySelector('.image-header');
            let imagesSlider = header.querySelector('.images-slider');
            let video, iframe, btn;

            if (imageHeader) {
                let videoWrapper = header.querySelector('.video-wrapper');
                if (videoWrapper) {
                    iframe = videoWrapper.querySelector('iframe');
                    btn = videoWrapper.querySelector('.play-btn-wrapper');
                    if(iframe && btn) {
                        video = new Player(iframe);
                    }
                }

                clickHandler = (evt) => {
                    let infos = evt.target.closest('.infos');
                    if (!infos) {
                        if (!header.classList.contains('active')) {
                            header.classList.add('active');
                            if(video) {
                                video.play().then().catch(e => console.log(e));
                            }
                        } else {
                            header.classList.remove('active');
                            if(video) {
                                video.pause().then().catch(e => console.log(e));
                            }
                        }
                    }
                }
            } else if(imagesSlider) {
                clickHandler = (evt) => {
                    if(!sukoaProject.isSmallScreen()) {
                        let infos = evt.target.closest('.infos');
                        if (!infos && !header.classList.contains('active')) {
                            header.classList.add('active')
                        }
                    }
                }
            }

            if (header && clickHandler) {
                header.addEventListener('click', clickHandler);
                // if (btn) {
                //     btn.addEventListener('click', clickHandler);
                // }
                if(!imageHeader && imagesSlider) {
                    document.addEventListener('click', evt => {
                        if (header.classList.contains('active') && !evt.target.closest('.images-slider')) {
                            header.classList.remove('active');
                        }
                    })
                }
            }
        }
    },

    articlesList() {
        sukoaProject.articlesListInitCollapsibles();
        sukoaProject.articlesListLoadList();
    },

    articlesListInitCollapsibles() {
        let articleListWrapper  = document.getElementsByClassName('articles-list-wrapper');

        let entryClickHandler = (evt, entry, entries) => {
            if (!evt.target.closest('a')) {
                if (entry.animation) {
                    entry.animation.on = true;
                    tools.each(entries, other => {
                        if (other.animation.open) {
                            other.animation.on = true;
                            sukoaProject.animEngine.addAnimation(other.animation);
                        }
                    });
                    sukoaProject.animEngine.addAnimation(entry.animation);
                }
            }
        }

        let prepareEntry = (entry, listWrapperMinHeight, listWrapper, entries) => {
            let collapsible = entry.querySelector('.collapsible');
            if (collapsible) {
                let collWrapper = collapsible.querySelector('.collapsible-wrapper');
                if (collWrapper) {
                    let name = "slideDown";
                    let param = {
                        open: entry.classList.contains('active'),
                        collapsible: collapsible,
                        collWrapper: collWrapper,
                        scrollMax: null,
                        steps: 10,
                        step: 1
                    };

                    let func = (anim, top) => {
                        if (anim.open) {
                            if (anim.step === 1) {

                                anim.collapsible.classList.remove('open');
                                anim.collapsible.style.maxHeight = 0;

                            }
                            if (anim.step >= 10) {
                                anim.elem.classList.remove('active');
                                anim.elem.classList.add('text-colored-third');
                                anim.elem.classList.remove('text-colored-second');
                                anim.open = false;
                            }
                        } else {
                            if (anim.step === 1) {
                                let scrollMax = anim.collapsible.getBoundingClientRect().top + anim.collWrapper.clientHeight - window.innerHeight;
                                if (scrollMax > 0) {
                                    anim.scrollMax = scrollMax + 30;
                                } else {
                                    anim.scrollMax = null;
                                }
                                anim.collapsible.style.maxHeight = anim.collWrapper.clientHeight + "px";
                                anim.elem.classList.add('text-colored-second');
                                anim.elem.classList.remove('text-colored-third');
                                anim.collapsible.classList.add('open');
                            }

                            if (anim.step >= 10) {
                                anim.elem.classList.add('active');
                                anim.open = true;
                            }

                            if (anim.scrollMax && anim.step <= anim.steps) {
                                window.scrollTo(0, top + anim.scrollMax / anim.steps);
                            }
                        }
                        anim.step++;
                        if (anim.step > 10) {
                            anim.switchOff(function (anim) {
                                anim.step = 1;
                                if (listWrapper.clientHeight > listWrapperMinHeight) {
                                    listWrapperMinHeight = listWrapper.clientHeight;
                                    listWrapper.style.minHeight = listWrapperMinHeight + "px";
                                }
                            });
                        }
                    };
                    entry.animation = new Animation(name, entry, func, param);
                }


                entry.addEventListener('click', evt => entryClickHandler(evt, entry, entries));
            }
        };


        tools.each(articleListWrapper, listWrapper => {
            let entries = listWrapper.getElementsByClassName('entry');
            let listWrapperMinHeight = listWrapper.clientHeight;

            tools.each(entries, entry => prepareEntry(entry, listWrapperMinHeight, listWrapper, entries));
        });
    },

    articlesListLoadList() {
        let allArticlesBtn = document.getElementById('all-articles');
        let listwrapper = document.querySelector('.articles-list');
        let clickFct = evt => {
            evt.preventDefault();
            allArticlesBtn.removeEventListener('click', clickFct);
            allArticlesBtn.style.display = 'none';
            allArticlesBtn.style.opacity = 0;
            let url = allArticlesBtn.getAttribute('href');
            if (url) {
                tools.ajxGet(url, req => {
                    let temp = document.createElement('div');
                    temp.innerHTML = req.responseText;
                    let list = temp.querySelector('.articles-list-wrapper');
                    if (list) {
                        listwrapper.insertAdjacentElement('beforeend', list);
                        let listHeight = list.getBoundingClientRect().height;
                        let name = 'scrollTo';
                        let topMax = listHeight > window.innerHeight ? window.innerHeight : listHeight;

                        tools.scrollTo(window, topMax, 500);
                        sukoaProject.articlesListInitCollapsibles();

                    }
                });
            }
        };

        if (allArticlesBtn && listwrapper) {
            allArticlesBtn.addEventListener('click', clickFct)
        }
    },

    searchButton() {
        let searchWrap = document.getElementById('search');
        if (searchWrap) {
            let searchBtn = searchWrap.querySelector('button');
            let searchInput = searchWrap.querySelector('input');

            if (searchBtn && searchInput) {
                searchBtn.addEventListener('click', evt => {
                    if (searchWrap.classList.contains('set')) {
                        searchWrap.classList.remove('set');
                        searchInput.value = '';
                    } else if (searchWrap.classList.contains('active')) {
                        if (searchInput.value !== '') {
                            window.location.href = searchWrap.getAttribute('data-href') + '?search=' + searchInput.value;
                        } else {
                            searchWrap.classList.remove('active');
                            searchWrap.classList.remove('close');
                        }
                    } else {
                        searchWrap.classList.add('active');
                        searchWrap.classList.add('close');
                        searchInput.focus();
                    }
                });

                searchInput.addEventListener('keyup', evt => {
                    if (evt.keyCode === 13 && searchInput.value !== '') {
                        window.location.href = searchWrap.getAttribute('data-href') + '?search=' + searchInput.value;
                    } else{
                        if(searchInput.value !== '' && searchWrap.classList.contains('close')) {
                            searchWrap.classList.remove('close')
                        } else if(searchInput.value === '' && !searchWrap.classList.contains('close')){
                            searchWrap.classList.add('close')
                        }
                    }
                })
            }
        }
    },

    navigation() {
        let nav = document.getElementById('main-nav');
        let navMainLis = nav.querySelectorAll('.has-subpages');

        let clickHander = (evt, li) => {
            evt.preventDefault();
            if (!li.classList.contains('open')) {
                evt.preventDefault();
                li.classList.add('open');
            }
        }

        let prepFn = li => {
            let a = li.querySelector('> a');
            a.addEventListener('click', e => clickHander(e, li));

        }

        tools.each(navMainLis, prepFn);

    },

    burger() {
        let burger = document.getElementById('burger');
        if (burger) {
            burger.addEventListener('click', evt => {

                if (burger.classList.contains('active')) {
                    burger.classList.remove('active');
                    burger.classList.add('rev');
                    document.body.classList.remove('navexp');
                } else {
                    burger.classList.remove('rev');
                    burger.classList.add('active');
                    document.body.classList.add('navexp');
                }
            })
        }

        let burgerNav = document.getElementById('burger-nav');
        if (burgerNav) {
            burgerNav.classList.add('js-handled');

            let clickHandler = (e, parent) => {

                if(parent.classList.contains('closed') || !parent.classList.contains('open')) {
                    e.preventDefault();
                    e.stopPropagation();
                    parent.classList.remove('closed');
                    parent.classList.add('open');
                } else if(e.layerX <= 20) {
                    e.preventDefault();
                    parent.classList.add('closed');
                    parent.classList.remove('open');
                }
            }

            tools.each(burgerNav.querySelectorAll('.has-subpages'), parent => {

                  let a = parent.classList.contains('section')
                      ? parent.querySelector('a.page-title')
                      : parent.children[0];
                  if(a) {
                      a.addEventListener('click', e => clickHandler(e, parent))
                  }
            })
        }
    },

    shareButtons() {
        let shareIconsWrapper = document.querySelector('.shareIcons');
        if (shareIconsWrapper) {
            let shareBtn = shareIconsWrapper.querySelector('.mobsharebtn');
            if (shareBtn) {
                shareBtn.addEventListener('click', evt => {
                    if(navigator.share) {
                        try {
                            let title = shareBtn.getAttribute('data-title');
                            let url = shareBtn.getAttribute('data-url');
                            let text = shareBtn.getAttribute('data-description');
                            navigator.share({title: title, url: url, text: text});
                        } catch(err) {
                            console.error("Navigator.Share not working on this browser");
                        }

                    } else {
                        if (!shareIconsWrapper.classList.contains('active')) {
                            shareIconsWrapper.classList.add('active');
                        } else {
                            shareIconsWrapper.classList.remove('active');
                        }
                    }

                })
            }
        }
    },

    printBtn() {
        let printBtns = document.getElementsByClassName('print-button');
        tools.each(printBtns, printBtn => {
            printBtn.addEventListener('click', evt => {
                window.print();
            })
        })
    }
};

window.sukoaUtils = {
    dcmadr: function (nnnn) {
        var a = "";
        for (var i = 0; i < nnnn.length; i++) {
            if (i % 3 === 0) {
                a += String.fromCharCode(nnnn.substr(i, 3));
            }
        }
        location.href = (a);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    sukoaProject.init();
});
